import { ApplicationState } from '../store';

// eslint-disable-next-line import/prefer-default-export
export const promoSelector = (state: ApplicationState) => state.promo;
